import React from 'react';
import ToggleButton from '../../common/ui/ToggleButton';
import PWAConfigForm from './pwa/PWAConfigForm';
import { PWA_CONFIG } from 'drapcode-constant';
import { drapcodeIcon } from '../../common/custom/icon-library';
import PermissionDenied from '../../common/PermissionDenied';
import { checkPWAPermission } from '../../common/utils/permissions';

const PWAConfigSection = ({
  enablePWA,
  pwaConfig,
  projectId,
  iPlugins,
  s3Url,
  saveProjectPwaConfigPending,
  permissionsArray,
  handleTogglePWA,
  handlePWAConfigSubmit,
  handlePWAConfigDelete,
  isReadOnly,
}) => {
  const isAllowed = checkPWAPermission();
  if (!isAllowed) {
    return <PermissionDenied message="PWA Configuration" />;
  }

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-violet">
          <i className={`wb ${drapcodeIcon('pwa')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">PWA Configuration</h4>
            <div className="card-cta">
              <div className="form-group">
                <div
                  className="form-check mr-2"
                  style={{ marginTop: 'revert', display: 'inline-block' }}
                >
                  <ToggleButton
                    name="enablePWA"
                    title="Enable PWA (Default: Disabled)"
                    text="Enable PWA"
                    bgColor="drapcode-violet"
                    onChange={isReadOnly ? undefined : handleTogglePWA}
                    isChecked={enablePWA ? 'checked' : ''}
                    isDisabled={isReadOnly}
                  />
                </div>
              </div>
            </div>
          </div>

          {enablePWA && (
            <PWAConfigForm
              pwaConfig={pwaConfig}
              projectId={projectId}
              plugins={iPlugins}
              s3Url={s3Url}
              handlePWAConfigSubmit={handlePWAConfigSubmit}
              handlePWAConfigDelete={handlePWAConfigDelete}
              showPWAConfigLoader={saveProjectPwaConfigPending}
              deleteFlag={permissionsArray.includes(PWA_CONFIG)}
              isReadOnly={isReadOnly}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PWAConfigSection;
